import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/icon_HiOutlineDocumentDownload.svg'


const _hoisted_1 = { class: "row q-col-gutter-md" }
const _hoisted_2 = { class: "row q-pb-xs" }
const _hoisted_3 = { class: "midia-app-label-sm" }
const _hoisted_4 = { class: "row q-pb-xs" }
const _hoisted_5 = { class: "midia-app-label-sm" }
const _hoisted_6 = { class: "row q-pb-xs" }
const _hoisted_7 = { class: "midia-app-label-sm text-grey-6" }
const _hoisted_8 = { class: "row items-center q-pb-x" }
const _hoisted_9 = { class: "midia-app-label-lg q-ml-sm ellipsis" }
const _hoisted_10 = { class: "row q-py-xs" }
const _hoisted_11 = {
  key: 0,
  class: "q-pa-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "q-pa-sm"
}

import { EnumButtonSizes } from '@/enums/enums'
import { computed, onMounted, ref } from 'vue'
import { DEFAULT_PC_GROUP_EXPORT_FILENAME } from '@/static/constantsInstitutional'
import moment from 'moment'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { watch } from 'vue'

const CHUNK_SIZE = 100
interface GrupoDistribuicao {
  nome: string
  dataInicio: string
  pcs: any[]
}

/*const gruposDistribuidos = computed((): GrupoDistribuicao[] => {
  if (!todosPcs.value.length) return []

  const dtIni = institutionalStore.institutionalDetail?.dtIniVigencia
  if (!dtIni) return []

  const nomeGrupos = ['D0', 'D1', 'D2', 'D3']
  const total = todosPcs.value.length

  // ✅ ≤ 100 → grupo único D0
  if (total <= CHUNK_SIZE) {
    return [{
      nome: 'D0',
      dataInicio: formatarData(dtIni, 0),
      pcs: todosPcs.value
    }]
  }*/

  // ✅ > 100 → distribui em grupos de 100
  /*const grupos: GrupoDistribuicao[] = []

  for (let i = 0; i < nomeGrupos.length; i++) {
    const inicio = i * CHUNK_SIZE
    const isUltimo = i === nomeGrupos.length - 1

    // ✅ último grupo absorve o restante
    const slice = isUltimo
      ? todosPcs.value.slice(inicio)
      : todosPcs.value.slice(inicio, inicio + CHUNK_SIZE)

    if (!slice.length) break

    grupos.push({
      nome: nomeGrupos[i],
      dataInicio: formatarData(dtIni, i),
      pcs: slice
    })

    if (!isUltimo && inicio + CHUNK_SIZE >= total) break
  }

  return grupos
})*/


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalDevicesDistributionSection',
  props: {
    pcsPorGrupo: {},
    pcs: {}
  },
  setup(__props: any) {

const props = __props


const institutionalStore = useInstitutionalStore()

const todosPcs = ref<any[]>([])
const loading = ref(false)

/* =====================
 * BUSCA TODAS AS PÁGINAS
 * ===================== */


/*watch(
  () => institutionalStore.institutionalDetail?.id,
  async (id) => {
    if (!id) return

    loading.value = true
    try {
      await institutionalStore.fetchPcsDistribuicao(id, 0)

      const dist = institutionalStore.distribuicao

      const totalPages = dist?.totalPcPages ?? 1
      const acumulado = [...(dist?.pcsTela || [])]

      for (let page = 1; page < totalPages; page++) {
        await institutionalStore.fetchPcsDistribuicao(id, page)

        const distPage = institutionalStore.distribuicao
        acumulado.push(...(distPage?.pcsTela || []))
      }

      todosPcs.value = acumulado

    } catch (error) {
      console.error('Erro ao buscar distribuição:', error)
    } finally {
      loading.value = false
    }
  },
  { immediate: true }
)*/
/* =====================
 * DISTRIBUIÇÃO D0~D3
 * ===================== */
const gruposDistribuidos = computed(() => {
  if (!props.pcsPorGrupo) return []

  const dtIni = institutionalStore.institutionalDetail?.dtIniVigencia ?? ''

  return Object.entries(props.pcsPorGrupo)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([grupo, pcs], index) => ({
      nome: grupo,
      dataInicio: formatarData(dtIni, index),
      pcs
    }))
})



/* =====================
 * DATAS
 * ===================== */
const formatarData = (date: string, diasOffset: number): string => {
  if (!date) return '-'

  return moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD'])
    .add(diasOffset, 'days')
    .format('DD/MM/YYYY')
}

/* =====================
 * DOWNLOAD
 * ✅ usa campos corretos do TelaDistribuicaoPcDTO
 * ===================== */
const exportCsv = (pcs: any[], filename: string) => {
  if (!pcs?.length) return

  const header = ['Codigo PC', 'Nome', 'Status', 'Motivo']


const rows = pcs.map((pc: any) => {
  const dist = props.pcs?.find(
    (p: any) => String(p.pc) === String(pc.codpontocaptura)
  )

  return [
    pc.codpontocaptura ?? '-',

    // ✅ agora pega o nome correto da tabela
    dist?.nome ?? pc.nompontocaptura ?? '-',

    dist?.status ?? '-',
    dist?.motivo ?? '-'
  ]
})


  const csvContent = [
    header.join(';'),
    ...rows.map(row => row.join(';'))
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${filename}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}


const onDownloadDevicesBtnClick = (grupo: GrupoDistribuicao) => {
  const baseName =
    DEFAULT_PC_GROUP_EXPORT_FILENAME?.replaceAll('{0}', grupo.nome) ||
    `pcs_grupo_${grupo.nome}`

  exportCsv(grupo.pcs, baseName)
}

const onDownloadDevicesGreenBtnClick = (grupo: GrupoDistribuicao) => {
  onDownloadDevicesBtnClick(grupo)
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposDistribuidos.value, (grupo) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12 col-sm-6 col-md-3",
        key: grupo.nome
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, "Dispositivos " + _toDisplayString(grupo.nome), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, "Início " + _toDisplayString(grupo.dataInicio), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(grupo.pcs.length) + " dispositivos", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_c_q_btn, {
              padding: "none",
              propBtnLabel: "",
              propBtnFunction: () => onDownloadDevicesGreenBtnClick(grupo),
              propBtnTransparent: true,
              propBtnSize: _unref(EnumButtonSizes).SMALL,
              propBorderless: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { size: "32px" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "download"
                    }, null, -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["propBtnFunction", "propBtnSize"]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(DEFAULT_PC_GROUP_EXPORT_FILENAME).replaceAll('{0}', grupo.nome)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_c_q_btn, {
              propBtnLabel: "Download",
              propBtnFunction: () => onDownloadDevicesBtnClick(grupo),
              propBtnTransparent: true,
              propBtnSize: _unref(EnumButtonSizes).SMALL
            }, null, 8, ["propBtnFunction", "propBtnSize"])
          ])
        ])
      ]))
    }), 128)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "midia-app-label-sm text-grey-6" }, "Carregando dispositivos...", -1)
        ]))]))
      : (gruposDistribuidos.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "midia-app-label-sm text-grey-6" }, "Nenhum dispositivo encontrado.", -1)
          ]))]))
        : _createCommentVNode("", true)
  ]))
}
}

})